// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-471 · UN DESPLIEGUE LARGO TAMPOCO ES UNA LECTURA ROTA
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  LO QUE DIJO EL DUEÑO (14-sep): «cuando se reinicia el servidor sale un mensaje molesto diciendo
//  que no se sabe si hay algun tecnico conectado a la clinica».
//
//  YA SE HABIA ARREGLADO UNA VEZ (2-sep) Y SE QUEDO CORTO. La banda de acceso del soporte
//  (components/AccesoSoporteBanner) reintenta el fallo TRANSITORIO —el servidor no contesta, o el
//  proxy da 502/503/504— cuatro veces, unos 15 segundos. Eso cubre un `pm2 restart`, pero un
//  despliegue de verdad instala dependencias y compila antes de levantar el proceso: el servidor
//  esta caido bastante mas de 15 segundos y la alarma roja salia igual, a toda la clinica.
//
//  LO QUE SE AÑADE: una ESPERA PARA EL TRANSITORIO. Mientras el fallo siga siendo de «no hay nadie
//  detras» y no lleve mas de GRACIA_REINICIO_MS seguido, la banda no dice «no se puede saber». Si
//  pasado ese tiempo sigue igual, ya no es un despliegue y SE DICE.
//
//  LO QUE NO CAMBIA, y es la mitad importante: un fallo que NO es transitorio (401, 403, 500 con
//  cuerpo, la migracion que falta) se dice AL MOMENTO, sin espera. El dato de esta banda es «hay
//  alguien de fuera dentro de las fichas de tus pacientes» y ese no puede esperar a nadie.
// ══════════════════════════════════════════════════════════════════════════════════════════════

// Dos minutos, contados desde el PRIMER fallo transitorio seguido (que ya llega tras los reintentos).
export const GRACIA_REINICIO_MS = 2 * 60 * 1000

// ¿Hay que decir YA que no se ha podido leer?
//   error       — el de la consulta (null si la ultima lectura fue bien).
//   transitorio — si ese error es de un servidor reiniciandose (lo decide la banda: esTransitorio).
//   desde       — cuando empezo el fallo transitorio seguido (ms), o null.
//   ahora       — el reloj (ms).
// Devuelve { ciego, desde }: `desde` es lo que hay que recordar para la siguiente vez.
//  B-683 (18-sep-2026) · Y SIN CONEXION TAMPOCO SE DICE. El dueño: «el mensaje que veo a menudo de "No
//  se puede saber si el soporte tecnico esta dentro de los datos de esta clinica" cada vez que accedo
//  con la cuenta de control horario, se va internet, hay algun error... Es molesto y de cara a otras
//  clinicas es un poco raro».
//  Y tiene razon en lo de fondo: cuando el navegador dice que NO HAY INTERNET, esta banda no ha
//  perdido una señal — es que no hay linea. No se sabe nada de nada, tampoco si hay correo o citas, y
//  nadie espera que cada pantalla saque su propia alarma roja por eso. El reloj de la espera TAMPOCO
//  corre mientras no hay linea: si no, con un corte de cinco minutos la alarma salta sola al volver,
//  cuando ya se puede leer perfectamente.
export function avisoDeLectura({ error, transitorio, desde = null, ahora, sinConexion = false }) {
  if (!error) return { ciego: false, desde: null }
  if (sinConexion) return { ciego: false, desde: null }
  if (!transitorio) return { ciego: true, desde: null }
  const inicio = desde == null ? ahora : desde
  return { ciego: ahora - inicio >= GRACIA_REINICIO_MS, desde: inicio }
}
